<template>
    <transition
        enter-class="opacity-0"
        enter-active-class="transition-opacity duration-200"
        leave-to-class="opacity-0"
        leave-active-class="transition-opacity duration-200"
    >
        <Layout v-show="ready"
                container-class="flex flex-col justify-center min-h-screen py-10 sm:min-h-0 bg-primary">
            <div v-if="ready" class="w-full max-w-sm px-10 mx-auto">
                <div class="flex justify-center mb-8">
                    <img :src="config.service_logo" :alt="config.service_name"
                         class="block w-auto h-12">
                </div>
                <h1 class="mb-4 text-xl font-bold leading-tight text-center text-highlight-100">
                    {{ _('device_flow_title') }}
                </h1>
                <p class="mb-8 text-sm text-center text-highlight-60">
                    {{ _('device_flow_step_1') }}
                </p>
                <p class="mb-8 text-center text-highlight-60">
                    {{ _('device_flow_description') }}
                </p>
                <p class="mb-8 text-center text-highlight-60"
                    v-html="_('device_flow_instructions',  {service_name: config.service_name})">
                </p>

                <form @submit.prevent="submit">
                    <DeviceFlowCodeField
                        class="mb-6"
                        :label="_('device_flow_input')"
                        v-model="code"
                        :validation.sync="valid.code"
                    />

                    <p v-if="displayError !== false" class="px-4 mb-4 text-xs text-center text-error">
                        {{ displayError }}
                    </p>

                    <BaseButton type="button" :disabled="!isValid">
                        {{ _('device_flow_button') }}
                    </BaseButton>
                </form>
            </div>
            <Portal to="spinner">
                <div v-if="loading"
                     class="fixed inset-0 flex flex-col items-center justify-center p-8 bg-background-80">
                    <div class="mb-20">
                        <BaseSpinner/>
                    </div>
                </div>
            </Portal>
        </Layout>
    </transition>
</template>
<script>
import { mapGetters } from 'vuex'
import NProgress from 'nprogress'
import Layout from '@/components/Layout.vue'
import BaseButton from '@/components/Base/BaseButton.vue'
import BaseSpinner from '@/components/Base/BaseSpinner.vue'
import DeviceFlowCodeField from '@/components/Form/Fields/DeviceFlowCodeField.vue'
import DeviceFlowService from '@/services/DeviceFlowService'

export default {
    components: {
        Layout,
        BaseButton,
        BaseSpinner,
        DeviceFlowCodeField,
    },
    data() {
        return {
            deviceFlowService: new DeviceFlowService(),
            code: '',
            displayError: false,
            valid: {
                code: false,
            },
            ready: false,
            loading: false,
            config: '',
        }
    },
    computed: {
        ...mapGetters({
            fetched: 'localisation/fetched',
            _: 'localisation/translate',
            client: 'settings/getClient',
            params: 'settings/get',
            authenticated: 'user/authenticated',
            error: 'charge/error',

        }),
        isValid() {
            return Object.keys(this.valid)
                .every((field) => this.valid[field])
        },
        title() {
            return this.$router.currentRoute.name
        },
    },
    watch: {
        fetched: {
            immediate: true,
            deep: true,
            handler(fetched) {
                if (fetched) {
                    setTimeout(() => {
                        this.ready = true
                        NProgress.done()
                    }, 1000)
                }
            },
        },
        error: {
            immediate: true,
            handler(error) {
                if (error) {
                    this.loading = false
                    this.displayError = error
                }
            },
        },
    },
    created() {
        NProgress.start()
    },
    async mounted() {
        this.config = await import(`@/resources/${this.client}`)
    },
    methods: {
        submit() {
            if (this.isValid) {
                this.loading = true
                this.displayError = false;

                this.deviceFlowService
                    .activate(this.params, this.authenticated, this.code)
                    .then((response) => {
                        this.statusCheck(response.data.verification_uri)
                    })
                    .catch((error) => {
                        if (error.response.status === 401) {
                            this.recoverActivateCallback(error.response.request.responseURL)
                        } else {
                            this.loading = false
                            this.displayError = error.response.data.message
                        }
                    })
            }
        },
        recoverActivateCallback(callbackurl) {
            this.deviceFlowService
                .activateCallback(this.params, this.authenticated, callbackurl)
                .then((response) => {
                    this.statusCheck(response.data.verification_uri)
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.recoverActivateCallback(error.response.request.responseURL)
                    } else {
                        this.loading = false
                        this.displayError = error.response.data.message
                    }
                })
        },
        statusCheck(verificationUri) {
            let status = null

            const check = () => {
                this.deviceFlowService
                    .status(this.params, verificationUri)
                    .then((response) => {
                        status = response.data.status
                    })
            }

            const loop = setInterval(() => {
                check()

                if (status && status === 'Completed') {
                    clearInterval(loop);
                    this.$router.push({ name: 'DeviceFlowSuccess' })
                }
            }, (1000 * 5))

            setTimeout(() => {
                clearInterval(loop)
            }, (1000 * 300))
        },
    },
}
</script>
